import styled from 'styled-components';
import { StyledInput } from '../../main/theme';

export const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin: ${({ theme }) => `${theme.margin.xxlarge} 0 0`};

  > h1 {
    margin: ${({ theme }) => `0 0 ${theme.margin.standard}`};
  }

  > textarea {
    margin: ${({ theme }) => `0 0 ${theme.margin.standard}`};
  }
`;

export const NameActionsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin: ${({ theme }) => `${theme.margin.standard} 0 0`};
`;

export const ColourSelectionWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin: ${({ theme }) => `0 0 ${theme.margin.large}`};
`;
export const ColourSelectionItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin: ${({ theme }) => `0 ${theme.margin.xxlarge}`};
`;

export const NameInput = styled(StyledInput)`
  margin: ${({ theme }) => `0 0 ${theme.margin.standard} 0`};
`;
